/*eslint-disable*/ export const messages = JSON.parse("{\"textarea.label.optional\":[\"Valinnainen\"]}");
//# sourceMappingURL=messages.mjs.map